(function(){
'use strict';

/* MAJ 2026-08-09 (LOT 3 chantier 4 agents, T3.8) : le MutationObserver etait installe sur
   document.body en subtree sur TOUTES les pages, et relance a chaque mutation, pour zero
   element [data-gdp-card] sur la plupart d entre elles. Cout permanent sur l INP.
   Il n est desormais installe que si au moins une carte existe au demarrage. */

var fmt=new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'EUR'});

function initCard(card){
  if(card._gdp)return;
  card._gdp=true;

  var pills=card.querySelectorAll('.gdp-pill');
  var atcBtn=card.querySelector('.gdp-atc');
  if(!atcBtn)return;
  if(!pills.length){atcBtn.disabled=true;return;}
  var originalLabel=atcBtn.textContent;

  var saleEl=card.querySelector('.gdp-price-wrapper sale-price');
  var selectedId=null;

  function selectPill(pill){
    if(card._gdpPending||pill.disabled)return;
    for(var i=0;i<pills.length;i++)pills[i].classList.remove('is-active');
    pill.classList.add('is-active');
    selectedId=pill.dataset.variantId;
    card.querySelectorAll('a[href*="/products/"]').forEach(function(link){
      try {var url=new URL(link.href,window.location.origin);url.searchParams.set('variant',selectedId);link.href=url.href;} catch(_) {}
    });

    var price=+pill.dataset.price;
    var cmp=+pill.dataset.compareAt;

    if(saleEl){
      var sr=saleEl.querySelector('.sr-only');
      saleEl.textContent=fmt.format(price/100);
      if(sr)saleEl.prepend(sr);
      saleEl.className=saleEl.className.replace(cmp>price?'text-subdued':'text-on-sale',cmp>price?'text-on-sale':'text-subdued');
    }

    var cmpEl=card.querySelector('.gdp-price-wrapper compare-at-price');
    if(cmp>price){
      if(!cmpEl){
        cmpEl=document.createElement('compare-at-price');
        cmpEl.className='text-subdued line-through';
        card.querySelector('.gdp-price-wrapper price-list').appendChild(cmpEl);
      }
      var sr2=cmpEl.querySelector('.sr-only');
      cmpEl.textContent=fmt.format(cmp/100);
      if(sr2)cmpEl.prepend(sr2);
      cmpEl.style.display='';
    } else if(cmpEl){
      cmpEl.style.display='none';
    }
  }

  selectPill(pills[0]);

  for(var i=0;i<pills.length;i++){
    pills[i].addEventListener('click',function(){selectPill(this);});
  }

  atcBtn.addEventListener('click',function(){
    if(!selectedId||card._gdpPending||atcBtn.disabled)return;
    var bus=window.GDPCart;
    if(!bus){var link=card.querySelector('a[href*="/products/"]');if(link)window.location.href=link.href;return;}
    card._gdpPending=true;atcBtn.disabled=true;atcBtn.setAttribute('aria-busy','true');
    atcBtn.textContent='…';
    bus.addItems([{id:selectedId,quantity:1}]).then(function(){
      card._gdpPending=false;atcBtn.disabled=false;
      atcBtn.textContent='✓ '+bus.labels.added;
      atcBtn.classList.add('is-success');
      setTimeout(function(){if(!card._gdpPending){atcBtn.textContent=originalLabel;atcBtn.classList.remove('is-success');}},2000);
    }).catch(function(error){
      card._gdpPending=false;atcBtn.disabled=false; // 17/10/2026 (CODE-07) : le bouton redevient utilisable après un échec
      atcBtn.textContent=originalLabel;bus.showIssue(atcBtn,error);
    }).finally(function(){atcBtn.removeAttribute('aria-busy');});
  });
}

function initAll(){
  var cards=document.querySelectorAll('[data-gdp-card]');
  for(var i=0;i<cards.length;i++)initCard(cards[i]);
}

function boot(){
  initAll();
  if(!document.querySelector('[data-gdp-card]')) return;   // aucune carte ici : pas d observateur
  new MutationObserver(initAll).observe(document.body,{childList:true,subtree:true});
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',boot);
}else{
  boot();
}
})();